module.exports = __webpack_public_path__ + "img/multiproduct.2168a295.png";